const LOCAL_STORAGE_OFFER_KEY = '_redeemed_offer'
const LOCAL_STORAGE_OFFER_ID_KEY = '_redeemed_offerPropositionId'
const LOCAL_STORAGE_OFFER_REDEEM_EXPIRE_KEY = '_redeemed_offer_expiresAt'
const DEFAULT_REDEEM_MINUTES = 15

const OFFERS_TAB = { id: 'offers', text: 'account.rewards.offers' }
const VOUCHERS_TAB = { id: 'vouchers', text: 'account.rewards.vouchers' }

export {
  LOCAL_STORAGE_OFFER_ID_KEY,
  LOCAL_STORAGE_OFFER_KEY,
  LOCAL_STORAGE_OFFER_REDEEM_EXPIRE_KEY,
  DEFAULT_REDEEM_MINUTES,
  OFFERS_TAB,
  VOUCHERS_TAB,
}
